import { Divider } from '../Divider';
import { DETAIL_TONE_LABELS } from './constants';
import { InfoSection } from './InfoSection';
import { buildPersonalColor, renderValue, toLabel } from './utils';

import type { GoodsDetailProps, InfoRow } from './types';

export const GoodsDetail = ({ data }: GoodsDetailProps) => {
    const { thumb$, nameOfBrand, name, nameOfColor, analysis$ } = data;

    const imageUrl = thumb$?.url;
    const brandName = nameOfBrand;
    const productName = name;
    const colorName = nameOfColor;
    const personalColor = buildPersonalColor(analysis$?.season, analysis$?.tone);
    const personalDetailColor = toLabel(analysis$?.detailTone, DETAIL_TONE_LABELS);
    const imageAlt = [brandName, productName].filter(Boolean).join(' ').trim() || '상품 이미지';

    const productRows: InfoRow[] = [
        { label: '브랜드명', value: brandName },
        { label: '제품명', value: productName },
        { label: '컬러명', value: colorName },
    ];

    const beautyRows: InfoRow[] = [
        { label: '퍼스널컬러', value: personalColor },
        { label: '퍼스널컬러 세부톤', value: personalDetailColor },
    ];

    return (
        <>
            <section aria-labelledby="product-image-heading" className="-mx-4">
                <figure className="w-full h-full flex flex-col items-center justify-center">
                    {imageUrl ? (
                        <img src={imageUrl} alt={imageAlt} className="w-full object-contain" />
                    ) : (
                        <div className="w-full h-64 bg-gray-200 flex items-center justify-center">
                            <span className="text-gray-500">이미지 없음</span>
                        </div>
                    )}
                    <figcaption id="product-image-heading" className="sr-only">
                        {renderValue(brandName)} {renderValue(productName)}
                    </figcaption>
                </figure>
            </section>

            <InfoSection title="제품정보" rows={productRows} />

            <Divider />
            <InfoSection title="뷰티정보" rows={beautyRows} />
        </>
    );
};
